// extracted by mini-css-extract-plugin
export default {"congratsPopup":"CongratsPopup_congratsPopup__W9phH","copyData":"CongratsPopup_copyData__txi0g","copiedBox":"CongratsPopup_copiedBox__oKIzq"};